import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Globals } from '../../../_globals';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ProductsService } from '../../../_services/products.service';
import { NotificationService } from 'app/_services/notification.service';
import { errorHandler } from '@angular/platform-browser/src/browser';

@Component({
  selector: 'app-product-dialog',
  templateUrl: './product-dialog.component.html',
})
export class ProductDialogComponent implements OnInit, OnDestroy {
  @Input() display: boolean;
  @Output() displayChange = new EventEmitter();
  @Output() updateProductList = new EventEmitter();
  @Input() productId: string;

  title = 'Product Details';
  tabItems: any;

  dialog: any;

  store: any;

  selectedProduct: any = null;
  toolkitProduct: any = null;

  constructor(public globals: Globals, public router: Router, private _productsService: ProductsService, public notificationService: NotificationService, public cookieService: CookieService) {
    // Handle Store Cookies
    const hasCurrentStore = cookieService.check('currentStore');
    if (hasCurrentStore) {
      this.store = JSON.parse(cookieService.get('currentStore'));
    } else {
      this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
    }
  }

  ngOnInit() {
    // console.log('product dialog init', this.display);
    // this.tabItems = [
    //   { label: 'Details', icon: 'fas fa-pencil-alt' },
    //   { label: 'Media', icon: 'fa fa-fw fa-calendar' },
    //   { label: 'Nutrition', icon: 'fa fa-fw fa-book' },
    //   { label: 'Ingredients & Allergens', icon: 'fa fa-fw fa-support' },
    //   { label: 'Warehouse', icon: 'fa fa-fw fa-support' },
    // ];
  }

  updateProduct() {
    console.log('should update product');
    this.getProduct(this.productId);
    this.dialog.positionOverlay();
  }

  saveAll() {
    console.log('save all', this.selectedProduct);
    const body = {
      id: this.selectedProduct.id,
      description: this.selectedProduct.description,
      discontinued: this.selectedProduct.discontinued,
      displayName: this.selectedProduct.displayName,
      ean: this.selectedProduct.ean,
      categoryId: this.selectedProduct.categoryId,
      categoryKioskId: this.selectedProduct.categoryKioskId,
      foodToGoCategoryId: this.selectedProduct.foodToGoCategoryId,
      managed: this.selectedProduct.managed,
      name: this.selectedProduct.name,
      price: this.selectedProduct.price,
      productCode: this.selectedProduct.productCode,
      sortOrder: this.selectedProduct.sortOrder,
      allergensApiProductId: this.selectedProduct.allergensApiProductId,
      enabled: this.selectedProduct.enabled,
      alwaysInStock: this.selectedProduct.alwaysInStock,
      ageRestriction: this.selectedProduct.ageRestriction,
      ingredients: this.selectedProduct.ingredients,
      nutrition: this.selectedProduct.nutrition,
    };
    this._productsService.editProduct(body).subscribe((data: any) => {
      this.updateProductList.emit(true);
      this.notificationService.notify('success', 'Product Updated', 'Product has successfully been updated', 'top', 'right');

      this.display = false;
    });
  }

  onShow(event, dialog) {
    this.dialog = dialog;
    // console.log('dialog show e');
    this.title = 'Loading Product #' + this.productId + '...';

    // setTimeout(() => {
    //   dialog.maximize();
    // }, 0);

    this.getProduct(this.productId);
    this.getToolkitProduct(this.productId);
  }

  // Get Product by id
  public getProduct(id) {
    this._productsService.getProductById(id).subscribe((data: any) => {
      // console.log('Single Product ', data);
      this.selectedProduct = data;
      this.selectedProduct.images.sort(this.compareById);

      this.title = 'Edit ' + this.selectedProduct.displayName + ' (#' + this.productId + ')';
      if (this.selectedProduct.managed) {
        this.title += ' (POS Managed)';
      }

      setTimeout(() => {
        this.dialog.positionOverlay();
      }, 0);
    });
  }

  // Get Product by id
  public getToolkitProduct(id) {
    this.toolkitProduct = null;
    this._productsService.getToolkitProductById(id).subscribe((data: any) => {
      // console.log('Toolkit Product ', data);
      this.toolkitProduct = data;
    });
  }

  compareById(a, b) {
    if (a.id < b.id) {
      return -1;
    }
    if (a.id > b.id) {
      return 1;
    }
    return 0;
  }

  tabChanged(e) {
    if (!this.dialog.maximized) {
      setTimeout(() => {
        this.dialog.positionOverlay();
      }, 0);
    }
  }

  onClose() {
    // console.log('dialog close');

    this.selectedProduct = null;
    this.displayChange.emit(false);
  }

  // Work against memory leak if component is destroyed
  ngOnDestroy() {
    // console.log('dialog destroy');
    this.selectedProduct = null;
    this.displayChange.unsubscribe();
    this.updateProductList.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dialogs/product-detail/product-dialog.component.ts